import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 10.007c.055-.005.11-.007.167-.007H12V5H4v5.007ZM2 14V3.996A.997.997 0 0 1 3 3h10a1 1 0 0 1 1 1v7c0 .552-.447 1-.999 1H4.167L2 14Z"
    />
  </svg>
);
export default IconCommentStrokedSizeS;
